import { ChangeDetectorRef, Component, OnDestroy, OnInit, SimpleChanges, TemplateRef, ChangeDetectionStrategy, OnChanges, inject, output, signal, viewChild, input, linkedSignal } from '@angular/core';
import {Campaign, Influencer, InfluencerType} from '@app/modules/shared/models';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import {InfluencerSharedService} from '@app/services/influencer-shared.service';
import {GlobalprojectService} from '@app/services/global.service';
import {SharedService} from '@app/services/shared.service';
import Swal from 'sweetalert2';
import {ToastrService} from 'ngx-toastr';
import {ProjectService} from '@app/services/project.service';
import {ConfigsService} from '@app/services/configs.service';
import {select, Store} from '@ngrx/store';
import {Actions, ofType} from '@ngrx/effects';
import {
  getInfluencerError,
  getInfluencersProjectSegment,
  getInfluencersTypes,
  getInfluencerSuccess,
  getProjects,
  IAuthenticationState,
  IInfluencersState,
  InfluencersProjectSegment,
  InfluencersTypeList,
  IProjectState,
  ProjectList,
  ResetInfluencerState,
  getPaginatedInfluencers,
  InfluencersListByProjectPaginate,
  InfluencersListByProjectPaginateError,
  getBulkInfluencers,
  InfluencersDelete,
  ISegmentsState,
  InfluencersBulkStatus,
  InfluencersBulk,
  CampaignGet,
  getCampaignError,
  getCampaignUpdate,
  getCampaign,
  getLoggedInUser,
  ICampaignState, InfluencersExport, UploadToSignedUrl, getFileUploadProgress, getUploadToSignedUrl, IFileUploadState,
  InfluencersCampaignAppliedActionDelete
} from '@app/stores';
import {Subject, BehaviorSubject, Subscription} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {CreatableSelectComponent} from '@app/_components/creatable-select';
import {InfluencersImportComponent} from '@app/_components/influencers-import/influencers-import.component';
import {Observable} from 'rxjs';
import {LoaderService} from '@app/services/loader.service';
import { NgbModal, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import {ReferralsListComponent} from '@app/_components/referrals-list/referrals-list.component';
import {SegmentListComponent} from '@app/modules/segment/segment-list/segment-list.component';
import moment from 'moment-timezone';
import {SocketService} from '@app/services/socket.service';
import {Segment} from '@app/modules/shared/models/segment';
import {SegmentService} from '@app/services/segment.service';
import {TemplateGeneratorService} from '@app/services/template-generator.service';
import {AwsService} from '@app/services/aws.service';
import {InfluencerService} from '@app/services/influencer.service';
import {InfluencerApiService} from '@app/services/api/influencer-api.service';
import { SbTableComponent } from '@app/_components/unified/sb-table/sb-table.component';
import { SbTableActionsDirective, SbTableCellDirective, SbTableHeaderDirective } from '@app/_components/unified/sb-table/sb-table.directives';
import { SbTableColumn, SbTableOptions, SbTableRowBase, SbTableServerState } from '@app/_components/unified/sb-table/sb-table.types';
import { CdkDragDrop, moveItemInArray, CdkDropList, CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';

import {ListUrlStateService} from '@app/services/list-url-state.service';
import {SbModalService} from '@app/_components/unified/sb-modal/sb-modal.service';
import {SbModalButton} from '@app/_components/unified/sb-modal/sb-modal.types';
import { PageShellComponent } from '../../../_components/page-shell/page-shell.component';
import { EntityLinkDirective } from '../../../_components/unified/entity-form-modal/entity-link.directive';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { CreatableSelectComponent as CreatableSelectComponent_1 } from '../../../_components/creatable-select/creatable-select.component';
import { InfoPopoverComponent } from '../../../_components/info-popover/info-popover.component';
import { DatePipe } from '@angular/common';
import { SbBulkBarComponent } from '../../../_components/unified/sb-bulk-bar/sb-bulk-bar.component';
import { SbCheckboxComponent } from '../../../_components/unified/sb-checkbox/sb-checkbox.component';
import { SbInputSelectComponent } from '../../../_components/unified/sb-select/sb-select.component';
import { TzDatePipe } from '../../shared/pipes/tz-date.pipe';
import { TimeToRegisterFilterComponent } from '../../../_components/time-to-register-filter/time-to-register-filter.component';
import { humanDuration, parseTimeToRegister, timeToRegisterLabel } from '@app/_helpers/time-to-register';

/** One Custom column's filter: the text its value holds, or whether it is empty. */
interface CustomFieldFilter {
  contains?: string;
  presence?: 'empty' | 'not_empty';
}

const CUSTOM_FIELDS = Array.from({length: 10}, (_, i) => `custom_${i + 1}`);

@Component({
  selector: 'app-influencer-list',
  templateUrl: './influencer-list.component.html',
  styleUrls: ['./influencer-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PageShellComponent, EntityLinkDirective, RouterLink, MatMenuTrigger, MatMenu, CreatableSelectComponent_1, InfoPopoverComponent, CdkDropList, CdkDrag, CdkDragHandle, SbBulkBarComponent, SbCheckboxComponent, MatMenuItem, SbTableComponent, SbTableCellDirective, SbTableHeaderDirective, SbTableActionsDirective, ReactiveFormsModule, FormsModule, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbPopover, SbInputSelectComponent, DatePipe, TzDatePipe, TimeToRegisterFilterComponent]
})
export class InfluencerListComponent implements OnInit, OnDestroy, OnChanges {
  private listUrlState = inject(ListUrlStateService);
  private authenticationStore = inject<Store<IAuthenticationState>>(Store);
  private influencerStore = inject<Store<IInfluencersState>>(Store);
  private segmentStore = inject<Store<ISegmentsState>>(Store);
  private segmentService = inject(SegmentService);
  private configs = inject(ConfigsService);
  private sharedService = inject(SharedService);
  private influencerSharedService = inject(InfluencerSharedService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private toastr = inject(ToastrService);
  private projectService = inject(ProjectService);
  private globalprojectService = inject(GlobalprojectService);
  private projectStore = inject<Store<IProjectState>>(Store);
  private loaderService = inject(LoaderService);
  private _modalService = inject(NgbModal);
  private readonly socketService = inject(SocketService);
  private campaignStore = inject<Store<ICampaignState>>(Store);
  private templateGeneratorService = inject(TemplateGeneratorService);
  private fileUploadStore = inject<Store<IFileUploadState>>(Store);
  private awsService = inject(AwsService);
  private influencerService = inject(InfluencerService);
  private influencerApiService = inject(InfluencerApiService);
  private sbModal = inject(SbModalService);
  private cdr = inject(ChangeDetectorRef);
  private actions$ = inject(Actions);

  readonly table = viewChild<SbTableComponent>('influencersTable');

  readonly selectedInfluencerInput = input(null, {alias: 'selectedInfluencer'});
  readonly selectedInfluencer = linkedSignal(() => this.selectedInfluencerInput());
  readonly selectedSourceTypeInput = input<string[]>([], {alias: 'selectedSourceType'});
  readonly selectedSourceType = linkedSignal(() => this.selectedSourceTypeInput());
  readonly selectedInfluencerSegmentPairsInput = input([
    { influencerType: null, segment: null, filteredSegments: [] }
], {alias: 'selectedInfluencerSegmentPairs'});
  readonly selectedInfluencerSegmentPairs = linkedSignal(() => this.selectedInfluencerSegmentPairsInput());
  readonly selectedSkippedInput = input<string[]>([], {alias: 'selectedSkipped'});
  readonly selectedSkipped = linkedSignal(() => this.selectedSkippedInput());
  readonly selectedEmailValidationStatusInput = input<string[]>([], {alias: 'selectedEmailValidationStatus'});
  readonly selectedEmailValidationStatus = linkedSignal(() => this.selectedEmailValidationStatusInput());
  readonly selectedEmailFailedReasonInput = input<string[]>([], {alias: 'selectedEmailFailedReason'});
  readonly selectedEmailFailedReason = linkedSignal(() => this.selectedEmailFailedReasonInput());
  readonly selectedDataRemovedInput = input(null, {alias: 'selectedDataRemoved'});
  readonly selectedDataRemoved = linkedSignal(() => this.selectedDataRemovedInput());
  readonly selectedAppliedAction = input<string[]>([]);
  readonly changeSelectedInfluencer = output<any>();
  readonly changeSelectedSourceType = output<any>();
  readonly changeSelectedSkipped = output<any>();
  readonly changeSelectedEmailValidationStatus = output<any>();
  readonly changeSelectedEmailFailedReason = output<any>();
  readonly changeSelectedDataRemoved = output<any>();
  readonly changeSelectedAppliedAction = output<any>();
  readonly selectedSegmentInput = input(null, {alias: 'selectedSegment'});
  readonly selectedSegment = linkedSignal(() => this.selectedSegmentInput());
  readonly changeSelectedSegment = output<any>();
  readonly changeSelectedInfluencerSegmentPairs = output<any>();
  readonly sendTestEmailsEmit = output<any>();
  readonly logsTable = viewChild<TemplateRef<any>>('logsTable');
  influencerTypesById = {};
  /** The campaign audience asks for its first page once its campaign is in; the project list at once. */
  readonly tableReady = signal(false);
  readonly totalRows = signal(0);
  /**
   * In the old table's order: the address keeps the sort by the column's place (`sort=13`, see
   * urlSortByIndex). The hidden columns stay in place, hidden by their class.
   */
  readonly tableColumns: SbTableColumn[] = this.buildTableColumns();
  readonly tableOptions: SbTableOptions = {
    serverSide: true,
    urlState: true,
    // The old table kept its sort in the address by the column's place (sort=13).
    urlSortByIndex: true,
    urlFilters: () => this.campId ? {} : {
      type: this.selectedInfluencer(),
      segment: this.selectedSegment(),
      source: this.selectedSourceType(),
      skip: this.selectedSkipped(),
      email: this.selectedEmailValidationStatus(),
      failed: this.selectedEmailFailedReason(),
      removed: this.selectedDataRemoved(),
      promo: this.selectedPromoCode,
      badge: this.selectedBadgeImageUrl,
      // Every key, so a filter cleared leaves the address too.
      ...Object.fromEntries(this.customFields.flatMap(field => [[field, null], [`${field}_contains`, null]])),
      ...this.customFieldParams(),
      timeToRegisterLt: this.timeToRegisterLt(),
    },
    pageLength: 100,
    lengthMenu: [50, 100, 500, 1000],
    // Create Time, newest first.
    defaultSort: {columnId: 'created_at', direction: 'desc'},
    // The list keeps its own selection (across pages) and bulk bar.
    selectable: false,
    searching: true,
    tableId: 'influencers-table',
  };
  showAll: boolean;
  includeAddedInfluencers = true;
  id: number;
  /** The page of influencers the table shows. */
  readonly influencersLocal = signal<Influencer[]>([]);
  influencersFile: File;
  submitted = false;
  public events: object;
  segmentsGlobal: any = [];
  filteredSegments: any = [];
  unaddedInfluencerSegmentPairs = [
    { influencerType: null, segment: null, filteredSegments: [] }
  ];
  unsubscriber = new Subject();
  influencerTypes: InfluencerType[] = [];
  filteredInfluencerTypes: InfluencerType[] = [];
  // The bulk action this page started and is waiting on, and what to say once it is done.
  // One at a time: the bar offers no action while one runs.
  bulkRun: {verb: string; done: string} | null = null;
  // The list's filters as its last request sent them. "All matching" sends the same, so the
  // server changes exactly the influencers this list shows.
  private listedFilters: {[key: string]: any} = {};
  referredByInfluencer = null;
  // "Move to segment" dialog
  moveTypeId: number = null;
  moveSegmentId: number = null;
  moveSegments: any[] = [];
  readonly moveButtons: SbModalButton[] = [
    {id: 'cancel', label: 'Cancel', style: 'default', dismiss: true},
    {id: 'move', label: 'Move', style: 'primary', closeValue: true, disabled: true}
  ];
  readonly moveToSegmentTpl = viewChild<TemplateRef<any>>('moveToSegmentTpl');
  readonly influencerSegment = viewChild<CreatableSelectComponent>('influencerSegment');
  loader$: Observable<boolean>;
  _object = Object;
  firstTime = false;
  pageNumber = 0;
  currentUser: any = {};
  private importDataValue: any = null;
  /** The records a bulk action refused (the error logs dialog). */
  get importData(): any {
    return this.importDataValue;
  }
  set importData(data: any) {
    this.importDataValue = data;
    const columns: string[] = (data && data['columns']) || [];
    this.importDataColumns = columns.map((name, index) => ({id: `col_${index}`, header: name, className: 'delete-log'}));
    const version = ++this.importDataVersion;
    this.importDataRows = ((data && data['list']) || []).map((record, index) => ({id: `${version}-${index}`, record}));
  }
  public importJobId: number;
  public socketSubscription: any;
  // The export dialog and the preference history dialog are views of their own, outside this
  // one: what they show is in signals.
  public readonly exportProgress = signal<any>({
    status: 'started',
    remainingTimeFormatted: '',
    elapsedTimeFormatted: '',
    progress: 0
  });
  public importProgress: any = {
    status: 'started',
    progress: 0
  };
  sourceTypes = [
    {name: 'API', value: 'api', checked: false},
    {name: 'Manual', value: 'manual', checked: false},
    {name: 'Widget', value: 'widget', checked: false},
    {name: 'Generic Widget', value: 'generic-widget', checked: false},
    {name: 'Join/Update Via URL', value: 'join-url', checked: false},
    {name: 'SSO', value: 'sso', checked: false},
    {name: 'Import', value: 'import', checked: false}
  ];
  skippedType = [
    {name: 'None Excluded', value: 'none', checked: false},
    {name: 'Excluded From Campaign', value: 'campaign_inclusion', checked: false},
    {name: 'Excluded From Receiving Campaign Email', value: 'campaign_email', checked: false},
  ];
  // Skip only means something inside a campaign, so only the campaign list starts filtered: it
  // leaves out contacts excluded from the campaign. The project list shows every contact, with
  // the same filter available but unset.
  private readonly campaignDefaultSkipped = ['none', 'campaign_email'];
  private skippedDefaultsAppliedFor: 'campaign' | 'project' | null = null;
  private urlFiltersRestored = false;
  emailValidationStatusType = [
    {name: 'Valid', value: 'valid', checked: false},
    {name: 'Invalid', value: 'invalid', checked: false},
    {name: 'Unchecked', value: 'unchecked', checked: false},
  ];
  emailFailedReasonType = [
    {name: 'Opened', value: 'opened', checked: false},
    {name: 'Clicked', value: 'clicked', checked: false},
    {name: 'Delivered', value: 'delivered', checked: false},
    {name: 'Failed', value: 'failed', checked: false},
    {name: 'Temporarily Failed', value: 'temporarily-failed', checked: false},
    {name: 'Queued', value: 'queue', checked: false},
    {name: 'Sent', value: 'sent', checked: false},
  ];
  dataRemovedType = [
    {name: 'Data removal', value: 'yes', checked: false},
    {name: 'No data removal', value: 'no', checked: false},
    {name: 'Marketing email opt-out', value: 'suppress_email', checked: false},
    {name: 'No email open tracking', value: 'suppress_email_open_tracking', checked: false},
    {name: 'No tracking', value: 'suppress_all_tracking', checked: false},
    {name: 'Email Custom Frequency', value: 'email_frequency_set', checked: false},
  ];
  appliedActionType: Array<{name: string; value: string; checked: boolean}> = [];
  private emailFrequencyLabels: {[key: string]: string} = {
    standard: 'Standard',
    weekly: 'Weekly',
    monthly: 'Monthly',
    pause_30: 'Paused 30 days',
    pause_90: 'Paused 90 days',
  };
  readonly preferenceHistory = signal<any[]>([]);
  readonly preferenceHistoryLoading = signal(false);
  preferenceHistoryInfluencer: Influencer = null;
  readonly preferenceHistoryUsers = signal<{[id: string]: string}>({});
  readonly preferenceHistoryTpl = viewChild<TemplateRef<any>>('preferenceHistoryTpl');
  selectedPromoCode = null;
  promoCodeType = [
    {name: 'Empty', value: 'empty'},
    {name: 'Not Empty', value: 'not_empty'},
  ];
  selectedBadgeImageUrl = null;
  badgeImageUrlType = [
    {name: 'Empty', value: 'empty'},
    {name: 'Not Empty', value: 'not_empty'},
  ];
  readonly customFields = CUSTOM_FIELDS;
  /**
   * The Custom columns' header filters, by field: the text the value holds, or whether it is
   * empty. Sent as `custom_<n>_contains` and `custom_<n>`, and kept in the project list's address
   * under the same names.
   */
  readonly customFieldFilters = signal<{[field: string]: CustomFieldFilter}>({});
  /**
   * The Time to register header filter: only contacts who registered in less than this many seconds
   * after the referrer's click (unknown ones left out); null for all. Sent and kept in the project
   * list's address as `timeToRegisterLt`.
   */
  readonly timeToRegisterLt = signal<number | null>(null);
  readonly timeToRegisterLabel = timeToRegisterLabel;
  /** What each Custom filter's text box holds, until it is applied. */
  customFieldDrafts: {[field: string]: string} = {};
  readonly customFieldPresenceTypes = [
    {name: 'Any value', value: ''},
    {name: 'Empty', value: 'empty'},
    {name: 'Not empty', value: 'not_empty'},
  ];
  // The bulk "Campaign exclusion" choices, worded as the Skip column and its filter word them.
  readonly skipActions = [
    {
      value: null, name: 'Remove exclusion', icon: 'fa-check-circle-o',
      title: (who: string) => `Remove the exclusion from ${who}?`,
      body: 'They are added to campaigns at launch and sent campaign emails.',
      confirm: 'Remove exclusion', done: 'Exclusion removed'
    },
    {
      value: 'campaign_inclusion', name: 'Exclude from campaign', icon: 'fa-ban',
      title: (who: string) => `Exclude ${who} from campaigns?`,
      body: 'They are not added to campaigns at launch and are sent no campaign emails.',
      confirm: 'Exclude', done: 'Influencers excluded from campaigns'
    },
    {
      value: 'campaign_email', name: 'Exclude from campaign emails', icon: 'fa-envelope-o',
      title: (who: string) => `Exclude ${who} from campaign emails?`,
      body: 'They are still added to campaigns at launch, but are sent no campaign emails.',
      confirm: 'Exclude from emails', done: 'Influencers excluded from campaign emails'
    },
  ];
  public loaderImport = new BehaviorSubject<boolean>(false);
  public loaderImport$ = this.loaderImport.asObservable();
  // The error logs table: client-side, unsorted, one column per column of the records.
  readonly importDataTableOptions: SbTableOptions = {
    pageLength: 10,
    lengthMenu: [10, 25, 50, 100],
    ordering: false,
    paging: true,
    searching: true,
    selectable: false,
    tableId: 'influencer-logs-table',
  };
  importDataColumns: SbTableColumn[] = [];
  /** Numbered per answer: a record's own `id` may be one of its columns. */
  importDataRows: SbTableRowBase[] = [];
  private importDataVersion = 0;
  masterSelected: boolean;
  selectAllInfluencer = false;
  pageLength = 0;
  influencerList: Influencer[] = [];
  influencerListIds: any = [];
  influencerCount = 0;
  segments: Segment[] = [];
  checkedInfluencer: any;
  excludedIdList = [];
  includedIdList = [];
  excludedPageList = [];
  includedPageList = [];
  /**
   * The page (from 1) the rows in `influencersLocal` are, which the selection keys its pages by.
   * While the next page loads they are still the page before, and the table still shows them.
   */
  private rowsPage = 1;
  public loaderDelete = new BehaviorSubject<boolean>(false);
  public loaderDelete$ = this.loaderDelete.asObservable();
  influencerError = '';
  segmentError = '';
  campId: number;
  campaignGetAction = false;
  // The default filters (audience type, first segment) follow only this list's own requests:
  // the add/edit modal fetches the same types and segments, and re-applying the defaults then
  // would replace the filters in use.
  typesGetAction = false;
  segmentsGetAction = false;
  audienceType: number;
  public step;
  segmentIsLoading = false;
  campaign: Campaign = null;
  uniqueImportString: any;
  public exportJobId: number;
  exportProcess = false;
  blobObject: any;
  fileResponse: any[] = [];
  fileName: any;
  readonly csvDownloadComplete = signal(false);
  exportModelRef: any;
  modelOpen = false;
  csvUrl: any;
  readonly csvDownload = viewChild<TemplateRef<any>>('csvDownload');
  constructor() {
    this.socketService.resetSocketData();
  }

  subscribeStores() {
    this.projectStore.pipe(select(getProjects))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(projects => {
        if (projects) {
          this.events = projects;
        }
      });

    this.influencerStore.pipe(select(getPaginatedInfluencers))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(paginatedInfluencers => {
        if (paginatedInfluencers) {
          this.rowsPage = Number(paginatedInfluencers.paging.page);
          this.influencersLocal.set(paginatedInfluencers.list.map((item) => ({
            ...item,
            selected: this.getInfluencerSelectedStatus(item.id, paginatedInfluencers.paging.page)
          })));

          const nonSelectInfluencer = this.influencersLocal().filter((item) => !item.selected);
          this.masterSelected = !(nonSelectInfluencer.length > 0);
          this.influencerCount = Number(paginatedInfluencers.paging.total) - this.excludedIdList.length;
          this.totalRows.set(Number(paginatedInfluencers.paging.total));
          // The selection and the counts the bulk bar shows.
          this.cdr.markForCheck();

          // A reload holds the page, which may no longer exist after a delete or rows leaving the
          // filter; server-side DataTables does not clamp it on its own. Once the table has this
          // answer (the next change detection), it steps back to the last page.
          const pages = this.pageLength > 0 ? Math.ceil(this.totalRows() / this.pageLength) : 0;
          if (pages > 0 && this.pageNumber >= pages) {
            setTimeout(() => this.table()?.goToPage(pages));
          }
        }
      }
      );

    this.influencerStore.pipe(select(getBulkInfluencers))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(influencerBulk => {
        if (influencerBulk) {
          // Refused before any job was queued (nothing matched, no access): no progress will
          // follow, so the bar must not keep waiting for one.
          if (influencerBulk !== true && influencerBulk.success === false && !influencerBulk.data && this.bulkRun) {
            this.toastr.error(influencerBulk.message || 'The bulk action could not be started', 'Error');
            this.loaderImport.next(false);
            this.endBulkRun();
            this.cdr.markForCheck();
            return;
          }
          if (influencerBulk !== true && influencerBulk.data) {
            let errorMessage = '';
            if(this.currentUser.id === influencerBulk.data.userId) {
              if (!influencerBulk.success) {
                this.importJobId = influencerBulk.data?.jobId;
                if (influencerBulk.error) {
                  if (influencerBulk.error.name === 'AppTimeoutError') {
                    errorMessage = 'Timeout';
                  }
                  if (influencerBulk.error.name === 'AppError') {
                    errorMessage = influencerBulk.message;
                  }
                  if (influencerBulk.error.name === 'AppValidationError') {
                    errorMessage = influencerBulk.error.orgMessage || 'Invalid Records';
                    this.importData = influencerBulk.data;
                    this.showDeleteLogs();
                  }
                }
                if (errorMessage) {
                  this.toastr.error(errorMessage, 'Error');
                }
              }
            }
          }
        }
      });

    this.influencerStore.pipe(select(getInfluencersProjectSegment))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(segments => {
        if (segments && segments.length > 0) {
          this.segmentsGlobal = segments;
          if (this.selectedInfluencer()) {
            this.filteredSegments = this.segmentsGlobal.filter(item => item.influencer_type_id === this.selectedInfluencer());
          }
          this.cdr.markForCheck();
        }
      });

    this.influencerStore.pipe(select(getInfluencerError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastr.error(error, 'Error');
        }
      });

    this.influencerStore.pipe(select(getInfluencerSuccess))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(success => {
        // Delete, removing an applied action, and the add/edit modal (it saves through this store).
        if (success) {
          this.reloadTable();
        }
      });

    this.influencerStore.pipe(select(getInfluencersTypes))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(influencerTypes => {
        if (influencerTypes && influencerTypes.length > 0) {
          this.influencerTypes = influencerTypes;
          this.influencerTypes.forEach(item => {
            this.influencerTypesById[item.id] = {};
            Object.keys(item.fields).forEach(key => {
              this.influencerTypesById[item.id][key] = true;
            });
          });

          if (this.audienceType && this.typesGetAction) {
            this.onInfluencerTypeSelected(0, this.influencerTypes.find(item => item.id === Number(this.audienceType)));
          }
          this.typesGetAction = false;
          // The type filter's choices, and the column classes that follow the types' fields.
          this.cdr.markForCheck();
        }
      });
    this.influencerStoreSubscribe();
    this.campaignStoreSubscribe();

    this.authenticationStore.pipe(select(getLoggedInUser))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(user => {
        if (user) {
          this.currentUser = user;
          this.cdr.markForCheck();
        }
      }
      );

  }

  influencerStoreSubscribe() {
    this.influencerStore.pipe(select(getInfluencersProjectSegment))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(segments => {
        if (segments && segments.length > 0) {
          this.segmentIsLoading = false;
          this.segmentsGlobal = segments;
          const applyDefaults = this.segmentsGetAction;
          this.segmentsGetAction = false;
          if (this.selectedInfluencer()) {
            this.filteredSegments = this.segmentsGlobal.filter(item => item.influencer_type_id === this.selectedInfluencer());

            //
            // Pre select the first segment if none is selected
            if (applyDefaults && !this.selectedSegment() && this.filteredSegments?.length && this.filteredSegments[0]?.id) {
              this.selectedSegment.set(this.filteredSegments[0]?.id);
              // The table's empty row (sb-table's own, in server-side mode).
              if (document.querySelector('#influencers-table .no-data-available')) {
                document.querySelector('#influencers-table .no-data-available').innerHTML = this.getMessage();
              }
            }
          }

          if (applyDefaults && this.audienceType) {
            this.onSegmentSelected(0, this.segmentsGlobal.find(item => item.influencer_type_id === Number(this.audienceType)));
          }

          // New segment options only; the filters in use are unchanged, so no reload.
          if (this.campId && this.selectedInfluencerSegmentPairs().length > 0) {
            this.refreshFilteredSegments(false);
          }
          // The segment filters, chosen and offered (the pairs change in place).
          this.cdr.markForCheck();
        }
      });


    this.fileUploadStore.pipe(select(getFileUploadProgress))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((data: any) => {
        // if (data !== undefined && data !== null) {
        //   this.importProgress = {
        //     status: 'uploading',
        //     progress: data
        //   };
        //   if (data >= 100) {
        //     this.importProgress = {
        //       status: 'started',
        //       progress: 0
        //     };
        //   }
        // }
      });

    this.fileUploadStore.pipe(select(getUploadToSignedUrl))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((data: any) => {
        if (data && this.fileResponse && this.fileResponse.length > 0) {
          // console.log('this.fileResponse', this.fileResponse);
          //this.csvUrl = this.fileResponse[0]['url'].split("?")[0];
          const a = document.createElement('a');
          a.href = this.fileResponse[0].url; // window.URL.createObjectURL(this.blobObject);
          a.download = this.fileName;
          a.click();
          // this.exportModelRef.close();
          this.csvDownloadComplete.set(true);
          this.setExportProgress({status: 'started', progress: '0'});
        }
      });

    this.influencerStore.pipe(select(getPaginatedInfluencers))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(paginatedInfluencers => {
        if (!paginatedInfluencers) {
          // The store forgets the page while the next one is asked for. The rows stay until it
          // comes: emptying them would answer the table's ask with no rows before the request
          // ended, and a failure would then find nothing waiting and show "No data available".
          return;
        }
        if (paginatedInfluencers.list.length > 0) {
          if (!this.modelOpen) {
            this.influencersLocal.set(paginatedInfluencers.list.map((item) => ({
              ...item,
              selected: this.getInfluencerSelectedStatus(item.id, paginatedInfluencers.paging.page)
            })));

            const nonSelectInfluencer = this.influencersLocal().filter((item) => !item.selected);
            this.masterSelected = !(nonSelectInfluencer.length > 0);
            this.influencerCount = Number(paginatedInfluencers.paging.total) - this.excludedIdList.length;
          }
        } else {
          this.influencersLocal.set([]);
          this.influencerCount = 0;
        }
        this.cdr.markForCheck();
      }
      );

    // The page could not be loaded: the table says so in place of its rows. The rows of the page
    // before go too, so the select-page box and the bulk bar do not act on rows no longer shown;
    // the table keeps showing the failure rather than an empty page.
    this.actions$.pipe(ofType(InfluencersListByProjectPaginateError), takeUntil(this.unsubscriber))
      .subscribe(() => {
        this.influencersLocal.set([]);
        this.influencerCount = 0;
        this.cdr.markForCheck();
      });

    this.influencerStore.pipe(select(getInfluencersTypes))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(influencerTypes => {
        if (influencerTypes && influencerTypes.length > 0) {
          this.influencerTypes = influencerTypes;
          this.influencerTypes.forEach(item => {
            this.influencerTypesById[item.id] = {};
            Object.keys(item.fields).forEach(key => {
              this.influencerTypesById[item.id][key] = true;
            });
          });
          this.cdr.markForCheck();
        }
      });
  }

  private setExportProgress(changes: any): void {
    this.exportProgress.update((progress) => ({...progress, ...changes}));
  }

  campaignStoreSubscribe() {
    this.campaignStore.pipe(select(getCampaign))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(campaign => {
        if (campaign && this.campaignGetAction) {
          this.campaignGetAction = false;
          this.campaign = campaign;
          this.templateGeneratorService.setCampaignValue(campaign);
          this.step = {
            ...this.step,
            params: {
              ...this.step.params,
              campaignId: campaign.id,
              campaignName: campaign.name
            }
          };

          this.filteredInfluencerTypes = this.influencerTypes;

          const selectedInfluencerValue = this.selectedInfluencer();
          if (campaign.segments && campaign.segments.length > 0) {
            const segment = campaign.segments[0];

            if (!selectedInfluencerValue) {
              this.selectedInfluencer.set(this.audienceType || segment.influencer_type_id);
            }

            this.filteredSegments = this.segmentsGlobal.filter(item => item.influencer_type_id === this.selectedInfluencer());
            this.selectedSegment.set(segment.id);
            this.route.queryParams.subscribe(async (queryParams) => {
              if(queryParams.selectedSegmentUrl){
                this.selectedSegment.set(queryParams.selectedSegmentUrl);
                this.selectedInfluencer.set(Number(queryParams.selectedInfluencerUrl));
                this.filteredSegments = this.segmentsGlobal.filter(item => item.influencer_type_id === this.selectedInfluencer());
                this.cdr.markForCheck();
                // alert(this.selectedSegment)
              }
            });
          } else {
            if (!selectedInfluencerValue) {
              if (this.audienceType) {
                this.selectedInfluencer.set(Number(this.audienceType));

                const selectedInfluencer = this.influencerTypes.find(influencerType => String(influencerType.id) === String(this.selectedInfluencer()));
                const selectedSegment = this.segmentsGlobal.find(segment => String(segment.influencer_type_id) === String(this.selectedInfluencer()));
                this.onInfluencerTypeSelected(0, selectedInfluencer);
                this.onSegmentSelected(0, selectedSegment);
              } else if (this.influencerTypes.length > 0) {
                this.selectedInfluencer.set(this.influencerTypes[0].id);
              }
              // Get segments
              this.getSegments();
            }
          }
          // Whatever the branches above or the address chose is kept.
          if (!this.selectedInfluencer() && this.audienceType) {
            this.selectedInfluencer.set(Number(this.audienceType));
          }
          this.startTable();
          // The campaign, its audience's filters and the step.
          this.cdr.markForCheck();
        }
      });


  }

  subscribeToSocket() {
    this.socketSubscription = this.socketService.sourceData.subscribe(
      (message: any) => {
        if (message?.data?.requesterType === 'influencer_bulk_operations' && (!this.importJobId || message?.data?.id === this.importJobId)) {

          //
          // Set job id
          this.importJobId = message.data.id;

          this.importProgress.status = message.data?.status;
          this.importProgress.progress = message?.data?.progress ? message?.data?.progress : 0;
          // The bulk bar's progress label.
          this.cdr.markForCheck();
          // adjust loading state for finished/failed
          if (['finished', 'failed'].includes(this.importProgress.status)) {
            const result = message?.data?.result;
            setTimeout(() => {
              this.loaderImport.next(false);
              // Keep status
              const status: string = this.importProgress?.status;
              // Restart progress upon failed
              if (status === 'failed') {
                this.bulkStatus();
                this.endBulkRun();
              } else if (status !== 'failed') {
                this.importJobId = null;
                if (status !== 'started') {
                  if (this.bulkRun) {
                    this.toastr.success(this.bulkDoneMessage(result), 'Success');
                  }
                  this.reloadTable();
                  this.endBulkRun();
                }
              }
              // The bulk run ended: the bar and the selection are cleared.
              this.cdr.markForCheck();
            }, 1500);
          }
        }
        if (message?.data?.requesterType === 'influencer_export' && (!this.exportJobId || message?.data?.id === this.exportJobId) && message?.data?.uniqueImportString === this.uniqueImportString) {
          if(!this.csvDownloadComplete()) {
            this.setExportProgress({status: 'started', progress: '0'});
          }
          // Set job id
          this.exportJobId = message.data.id;
          const rt = message?.data?.remainingTimeFormatted;
          this.setExportProgress({
            status: message.data?.result?.status,
            progress: message?.data?.result?.progress ? message?.data?.result?.progress : 0,
            remainingTimeFormatted: (rt && !rt.includes('NaN')) ? rt : ''
          });
          // adjust loading state for finished/failed
          const status: string = this.exportProgress()?.status;
          if (['finished', 'failed'].includes(this.exportProgress().status)) {
            setTimeout( async () => {
              this.loaderImport.next(false);
              // Keep status
              // Restart progress upon failed
              if (status === 'finished' && !this.exportProcess) {
                this.exportProcess = true;
                // const content = '\ufeff' + message?.data?.result?.headers + "\n" + message?.data?.result?.rows;
                // this.blobObject = new Blob([content], { type: 'text/csv' });
                // const file = new File([this.blobObject], message?.data?.result?.fileName, {
                // type: this.blobObject.type
                // });
                // this.fileName = message?.data?.result?.fileName;
                //console.log('message?.data?.result', message?.data?.result);
                if (message?.data?.result?.fileUrl) {
                  this.csvUrl = message?.data?.result?.fileUrl;
                  // this.fileResponse = await Promise.all([
                  // this.getSignedUrlFromFile(file),
                  // ]);
                  //this.fileUploadStore.dispatch(UploadToSignedUrl({ files: [{url: message?.data?.result?.fileUrl}] }));
                  // this.fileUploadStore.dispatch(UploadToSignedUrl({ files: message?.data?.result?.fileUrl }));

                  // Download export file
                  await this.downloadExportFile();

                  this.csvDownloadComplete.set(true);
                  this.setExportProgress({status: 'started', progress: '0'});
                }
                this.exportJobId = null;
              }
              if (status === 'failed') {
                this.csvDownloadComplete.set(false);
                this.exportJobId = null;
              }
            },1500);
          }
        }
      },
      (err) => console.error(err),
      () => console.warn('Completed!')
    );
  }

  async downloadExportFile() {
    const fileName = this.csvUrl.split('/').pop();
    const response = await fetch(this.csvUrl);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
  }

  getSignedUrlFromFile(file) {
    return new Promise((resolve, reject) => this.awsService.getAwsSignedUrl(file.name, file.type, true).subscribe((resp: any) => {
      resolve({
        url: resp.data.url,
        fileData: file
      });
    }, reject));
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

    const selectedSourceType = this.selectedSourceType();
    if (!selectedSourceType || selectedSourceType.length === 0) {
      this.selectedSourceType.set(this.sourceTypes
        .filter(s => s.checked)
        .map(s => s.value));
    }

    window.onunload = function() {
      localStorage.removeItem('influencerSearchValue');
    };
    // The campaign audience starts its table once the campaign is in (campaignStoreSubscribe).
    if (!this.route.snapshot.queryParams.campId) {
      this.tableReady.set(true);
    }
    this.loader$ = this.loaderService.loader$;
    // document.querySelector('.custom-table').classList.add('blur');
    this.influencerStore.dispatch(ResetInfluencerState({
      params: {error: null, influencersProjectSegment: [], influencerTypes: [], paginatedInfluencers: null, influencerBulk: null}
    }));

    this.subscribeStores();
    this.subscribeToSocket();

    this.route.params.pipe(takeUntil(this.unsubscriber)).subscribe((params) => {
      this.route.queryParams.pipe(takeUntil(this.unsubscriber)).subscribe(async (queryParams) => {
        this.campId = queryParams.campId;
        this.applyDefaultSkipped();
        this.restoreUrlFilters();
        this.audienceType = queryParams.audienceType;
        this.step = {title: 'Influencers', params: {projectId: params.id, campaignId: null, campaignName: null}};

        if (this.campId) {
          this.campaignGetAction = true;
          this.campaignStore.dispatch(CampaignGet(queryParams.campId, {
            options: JSON.stringify({
              include_segments: true,
              include_email_status: true,
              include_influencer_segments: true
            })
          }));
          this.loadAppliedActionOptions();
        }
        // The list's mode and the filters the address restored.
        this.cdr.markForCheck();
      });
    });
    this.firstTime = true;
    this.route.paramMap.pipe(takeUntil(this.unsubscriber)).subscribe(params => {
      this.id = this.campId ? +params.get('id') : +params.get('projectId');
      this.influencersLocal.set([]);
      this.setProjectId(this.id)  ;
      this.globalprojectService.updateProjectId(this.id);
      this.typesGetAction = true;
      this.influencerStore.dispatch(InfluencersTypeList({params: {influencer_fields: true}}));
      if (!this.firstTime) {
        this.reloadTable(false);
      }
      this.firstTime = false;
    });

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedInfluencerSegmentPairsInput) {
      const influencerType = this.selectedInfluencerSegmentPairs().length > 0 ? this.selectedInfluencerSegmentPairs()[0].influencerType : null;
      const addedSegmentIds = this.selectedInfluencerSegmentPairs().filter(pair => pair.segment).map(pair => pair.segment.id);
      if (this.campaign && this.campaign.influencer_segments) {
        const unaddedSegments = this.segmentsGlobal.filter(item => {
          let isUnadded = this.campaign.influencer_segments.includes(item.id) && !addedSegmentIds.includes(item.id);
          if (influencerType) {
            isUnadded = isUnadded && String(item.influencer_type_id) === String(influencerType.id);
          }
          return isUnadded;
        })
          .map(seg => ({ influencerType: this.influencerTypes.find(x => String(x.id) === String(seg.influencer_type_id)), segment: seg, filteredSegments: [] }));
        this.unaddedInfluencerSegmentPairs = unaddedSegments;
      }
    }
  }

  setProjectId(projectId) {
    this.segmentsGetAction = true;
    this.influencerStore.dispatch(InfluencersProjectSegment({projectId}));

  }


  getSegments() {
    if (!this.segmentIsLoading) {
      this.segmentIsLoading = true;
      const projectId = this.id;
      this.segmentsGetAction = true;
      this.influencerStore.dispatch(InfluencersProjectSegment({projectId}));
    }
  }
  sendTestEmails(influencer) {
    this.sendTestEmailsEmit?.emit(influencer);
  }

  /** The table asks for a page: the same request the old ajax made. */
  onTableState(state: SbTableServerState) {
    this.pageLength = state.pageLength;
    this.pageNumber = state.page - 1;
    // By the column the table sorts on (Update Time or Create Time), else the default.
    const sort = state.sort || this.tableOptions.defaultSort;
    const orderBy = {column: sort.columnId, dir: sort.direction};
    if (this.campId) {
      this.loadInfluencersCampaign(this.pageLength, state.search, orderBy);
    } else {
      this.loadInfluencers(this.pageLength, state.search, orderBy);
    }
  }

  /**
   * Shows the table, which asks for its first page; once it is there, asks for the current page
   * again (the old table was re-created from the address, which asked for the same page).
   */
  private startTable() {
    if (this.tableReady()) {
      this.table()?.reload();
    } else {
      this.tableReady.set(true);
    }
  }

  private buildTableColumns(): SbTableColumn[] {
    const self = this;
    const typeHas = (field?: string) => {
      const type = self.influencerTypesById[self.selectedInfluencer()];
      return !self.selectedInfluencer() || !!(field ? type?.[field] : type);
    };
    interface ColumnOptions {
      sortable?: boolean;
      hidden?: () => boolean;
      className?: string;
      headerClass?: string;
      rowSelector?: boolean;
    }
    const column = (id: string, header: string, options: ColumnOptions = {}): SbTableColumn => {
      const {sortable = false, hidden, className = '', headerClass = '', rowSelector} = options;
      return {
        id,
        header,
        sortable,
        className: className || undefined,
        headerClass: headerClass || undefined,
        rowSelector,
        // Read on every change detection, as the old [ngClass] was.
        get hidden() {
          return !!hidden && hidden();
        },
      };
    };
    const allColumns = (field?: string) => () => !self.showAll || !typeHas(field);
    const filterHeader = 'column-filter-header';
    return [
      column('select', '', {className: 'sb-table__select-col', headerClass: 'sb-table__select-col', rowSelector: true}),
      // The inaccurate-tracking mark, for those who see it: no header, nothing to sort by, as narrow
      // as the mark.
      column('tracking_source_flag', '', {
        className: 'influencer-mark-col', headerClass: 'influencer-mark-col',
        hidden: () => !self.currentUser?.can?.('index.all', 'influencer'),
      }),
      column('id', 'Id', {hidden: allColumns('id')}),
      column('name', 'Full Name', {hidden: () => !self.showAll && !self.hasNonPartnerInfluencerType()}),
      column('company', 'Company', {hidden: () => !self.showAll && !self.hasPartnerInfluencerType()}),
      column('impressions', 'Impressions', {hidden: () => !self.showAll}),
      column('referrals', 'Referrals'),
      column('links', 'Links'),
      column('applied_action', 'Applied Action', {hidden: () => !self.campId, headerClass: filterHeader}),
      column('email_delivery', 'Email Delivery', {hidden: () => !self.campId, headerClass: filterHeader}),
      column('preferences', 'Preferences', {headerClass: filterHeader}),
      column('source', 'Source', {headerClass: filterHeader}),
      column('registration_platform', 'API Integration', {hidden: () => !self.showAll}),
      column('updated_at', 'Update Time', {sortable: true}),
      // After Update Time, which keeps its place (sort=13). An old address sorted by Create Time
      // (sort=16) now names Skip, which does not sort, so it falls back to the default: Create Time.
      column('created_at', 'Create Time', {sortable: true}),
      column('email_validity', 'Email Validity', {headerClass: filterHeader}),
      column('skip', 'Skip', {headerClass: filterHeader, className: 'text-capitalize'}),
      ...[
        ['Email', 'email'], ['Image', 'image'], ['Influencer type', 'influencer_type_id'],
        ['Segment', 'project_influencer_segment_id'], ['Registration Url', 'registration_url'], ['Prefix', 'prefix'],
        ['First name', 'first_name'], ['Last name', 'last_name'], ['Suffix', 'suffix'], ['Phone', 'phone'],
        ['Video Url', 'video_url'], ['Booth Number', 'booth_number'], ['Promo Code', 'promo_code'],
        ['Badge Image Url', 'badge_image_url'], ['Platform Unique Id', 'platform_unique_id'], ['Job Title', 'job_title'],
        ['Sessions', 'sessions'],
      ].map(([header, field]) => column(field, header, {hidden: allColumns(field)})),
      ...CUSTOM_FIELDS.map((field, i) => column(field, `Custom ${i + 1}`, {hidden: allColumns(field), headerClass: filterHeader})),
      ...[
        ['Referred By', 'referred_by'], ['Referred Campaign Id', 'referred_by_campaign_id'],
        ['Referred Through Tracker Source', 'referred_through_tracker_source'], ['Created By', 'created_by'],
        ['Updated By', 'updated_by'],
      ].map(([header, id]) => column(id, header, {hidden: allColumns()})),
      // Last, so every older column keeps its place in the address (sort=13). Behind "Display all
      // columns", as Impressions and API Integration.
      column('referral_time_to_register', 'Time to register', {hidden: allColumns(), headerClass: filterHeader}),
    ];
  }

  checkReferredThroughTrackerSource(source = null) {
    let message = '';
    let isRedBackground = false;
    if (source) {
      if (source === 'ip' || source === 'client_fingerprint') {
        message = 'Conversion tracking source is not accurate, make sure the tracking script is added to all pages through the registration process on your site.';
        isRedBackground = true;
      } else if (source !== 'url' && source !== 'on_site_cookie') {
        message = 'Conversion tracking source is not optimal, make sure the tracking script is added to all pages through the registration process on your site.';
      }
    }
    return {message, isRedBackground};
  }

  getMessage() {
    const selectedInfluencer = this.selectedInfluencer();
    const selectedSegment = this.selectedSegment();
    if (!selectedInfluencer && !selectedSegment) {
      return 'Please select an influencer type';
    } else if (selectedInfluencer && !selectedSegment) {
      return 'Please select a segment';
    } else {
      return `Add individual influencer or Upload them in bulk. <br>
                         You can skip this step for now, you'll have the chance to add them before launching your campaign.
                        <div>
                          <a title="Add" class="cursor-pointer" onclick="window.dispatchEvent(new CustomEvent('emptyTableCallback', {detail: 'add'}))">
                            <img class="" src="../../assets/images/add-ic.png">
                          </a>
                          <a onclick="window.dispatchEvent(new CustomEvent('emptyTableCallback', {detail: 'import'}))" class="cursor-pointer" title="Import">
                            <img class="mx-2" src="../../assets/images/export-normal.png">
                          </a>
                          <a onclick="window.dispatchEvent(new CustomEvent('emptyTableCallback', {detail: 'skip'}))" class="cursor-pointer btn btn-default btn-sm" title="Skip">
                            Skip for now
                          </a>
                        </div>`;
    }
  }

  /**
   * Re-fetches through the table, so the request carries the table's own page, page length,
   * search and sort. A row action keeps the current page; a filter change goes back to the
   * first one. Calling the loaders directly would silently drop all four.
   */
  private reloadTable(keepPage = true) {
    this.table()?.reload(!keepPage);
  }

  private loadInfluencers(perPage: number, search: string, orderBy) {
    const selectedInfluencer = this.selectedInfluencer();
    const selectedSegment = this.selectedSegment();
    const selectedSourceType = this.selectedSourceType();
    const selectedSkipped = this.selectedSkipped();
    const selectedEmailValidationStatus = this.selectedEmailValidationStatus();
    const selectedEmailFailedReason = this.selectedEmailFailedReason();
    const selectedDataRemoved = this.selectedDataRemoved();
    this.listedFilters = {
      project_id: this.id,
      ...(selectedInfluencer ? {influencer_type_id: selectedInfluencer} : {}),
      ...(this.referredByInfluencer ? {referred_by: Number(this.referredByInfluencer.id)} : {}),
      ...(selectedSegment ? {project_influencer_segment_id: selectedSegment} : {}),
      ...(selectedSourceType && selectedSourceType.length > 0 ? {source: selectedSourceType.join(',')} : {}),
      ...(selectedSkipped && selectedSkipped.length > 0 ? {skip: selectedSkipped.join(',')} : {}),
      ...(selectedEmailValidationStatus && selectedEmailValidationStatus.length > 0 ? {email_validation_status: selectedEmailValidationStatus.join(',')} : {}),
      ...(selectedEmailFailedReason && selectedEmailFailedReason.length > 0 ? {email_failed_reason: selectedEmailFailedReason.join(',')} : {}),
      ...(selectedDataRemoved ? {influencer_preference: selectedDataRemoved} : {}),
      ...(this.selectedPromoCode ? {promo_code: this.selectedPromoCode} : {}),
      ...(this.selectedBadgeImageUrl ? {badge_image_url: this.selectedBadgeImageUrl} : {}),
      ...this.customFieldParams(),
      ...this.timeToRegisterParams(),
      search
    };
    this.influencerStore.dispatch(InfluencersListByProjectPaginate({
      params: {
        options: JSON.stringify({includePagination: true, orderBy}),
        ...this.listedFilters,
        page: this.pageNumber + 1,
        perPage
      }
    }));
  }

  private loadInfluencersCampaign(perPage: number, search: string, orderBy) {
    let selectedSegments = this.selectedInfluencerSegmentPairs().filter(x => x.segment !== null).map(x => x.segment.id);
    selectedSegments = [...new Set(selectedSegments)];

    const selectedInfluencerSegmentPairs = this.selectedInfluencerSegmentPairs();
    if (selectedInfluencerSegmentPairs.length === 1 &&
      (!selectedInfluencerSegmentPairs[0].influencerType ||
        !selectedInfluencerSegmentPairs[0].segment)) {
      selectedSegments = [];
    }

    const selectedInfluencerTypeId = selectedInfluencerSegmentPairs.length > 0 && selectedInfluencerSegmentPairs[0].influencerType
      ? selectedInfluencerSegmentPairs[0].influencerType.id
      : null;

    const selectedAppliedAction = this.selectedAppliedAction();
    const selectedSourceType = this.selectedSourceType();
    const selectedSkipped = this.selectedSkipped();
    const selectedEmailValidationStatus = this.selectedEmailValidationStatus();
    const selectedEmailFailedReason = this.selectedEmailFailedReason();
    const selectedDataRemoved = this.selectedDataRemoved();
    this.listedFilters = {
      project_id: this.id,
      campaign_id: this.campId,
      ...(this.referredByInfluencer ? {referred_by: Number(this.referredByInfluencer.id)} : {}),
      ...(selectedSegments.length > 0 ? {project_influencer_segment_ids: selectedSegments} : {}),
      ...(selectedInfluencerTypeId ? {influencer_type_id: selectedInfluencerTypeId} : {}),
      ...(selectedSourceType && selectedSourceType.length > 0 ? {source: selectedSourceType.join(',')} : {}),
      ...(selectedSkipped && selectedSkipped.length > 0 ? {skip: selectedSkipped.join(',')} : {}),
      ...(selectedEmailValidationStatus && selectedEmailValidationStatus.length > 0 ? {email_validation_status: selectedEmailValidationStatus.join(',')} : {}),
      ...(selectedEmailFailedReason && selectedEmailFailedReason.length > 0 ? {email_failed_reason: selectedEmailFailedReason.join(',')} : {}),
      ...(selectedDataRemoved ? {influencer_preference: selectedDataRemoved} : {}),
      ...(this.selectedPromoCode ? {promo_code: this.selectedPromoCode} : {}),
      ...(selectedAppliedAction && selectedAppliedAction.length > 0 ? {applied_action: selectedAppliedAction.join(',')} : {}),
      ...(this.selectedBadgeImageUrl ? {badge_image_url: this.selectedBadgeImageUrl} : {}),
      ...this.customFieldParams(),
      ...this.timeToRegisterParams(),
      ...(this.includeAddedInfluencers ? {include_campaign_influencers: 'true'} : {}),
      search
    };
    this.influencerStore.dispatch(InfluencersListByProjectPaginate({
      params: {
        options: JSON.stringify({includePagination: true, orderBy, includeEmailOpen: true, includeEmailClick: true, includeCampaignInfluencer: true}),
        ...this.listedFilters,
        page: this.pageNumber + 1,
        perPage
      }
    }));
  }
  getInfluencerSelectedStatus(id, pageNumber) {
    let result;
    if (this.selectAllInfluencer) {
      if (this.excludedPageList.includes(Number(pageNumber))) {
        result = !this.excludedIdList.includes(id);
      } else {
        result = true;
      }
    } else {
      // result = this.includedPageList.includes(Number(pageNumber));
      if (!this.includedPageList.includes(Number(pageNumber))) {
        result = this.includedIdList.includes(id);
      } else {
        result = true;
      }
    }
    return result;
  }


  loadAllEvents() {
    this.projectStore.dispatch(ProjectList());
  }

  viewInfluencer(id, itempKey, influencerId) {
    this.router.navigate([
      '/projects/' + id + '/influencers/view/' + influencerId
    ],
    { queryParams: { selectedInfluencerType: this.selectedInfluencer(), selectedSegment: this.selectedSegment(),campaignId: this.campId }}
    );
  }

  public changeStatus(influencer) {
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then(result => {
      if (result.value) {
        const {id} = influencer;
        this.influencerStore.dispatch(InfluencersDelete({influencerId: id}));
      }
    });
  }

  deleteAppliedAction(influencer) {
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then(result => {
      if (result.value) {
        const {id} = influencer;
        this.influencerStore.dispatch(InfluencersCampaignAppliedActionDelete({influencerId: id, campaignId: this.campId}) );
      }
    });
  }

  /** How many influencers the bulk bar acts on. */
  get bulkCount(): number {
    return this.selectAllInfluencer ? this.influencerCount : this.includedIdList.length;
  }

  get bulkRunning(): boolean {
    return !!this.bulkRun;
  }

  bulkProgressLabel(): string {
    return `${this.bulkRun?.verb || 'Working'}… ${Number(this.importProgress?.progress) || 0}%`;
  }

  /** "all 1,204 matching influencers", "12 influencers": what the dialogs say they act on. */
  private bulkSubject(): string {
    const count = this.bulkCount.toLocaleString();
    if (this.selectAllInfluencer) {
      return `all ${count} matching influencers`;
    }
    return `${count} ${this.bulkCount === 1 ? 'influencer' : 'influencers'}`;
  }

  /** The selection as the bulk endpoint takes it. */
  private bulkSelection() {
    return {
      influencerList: !this.selectAllInfluencer ? this.includedIdList : null,
      influencerType: this.selectedInfluencer(),
      influencerSegment: this.selectedSegment(),
      project_id: this.id,
      selectAll: this.selectAllInfluencer,
      excludedInfluencers: this.excludedIdList,
      ...(this.selectAllInfluencer ? {filters: this.listedFilters} : {})
    };
  }

  private runBulk(verb: string, done: string, data: {[key: string]: any}) {
    // After a confirm dialog, not a template event: the bar shows the run.
    this.cdr.markForCheck();
    this.bulkRun = {verb, done};
    this.loaderImport.next(true);
    this.influencerStore.dispatch(InfluencersBulk({data: {...this.bulkSelection(), ...data}}));
  }

  private endBulkRun() {
    this.importProgress = {
      status: 'started',
      progress: 0
    };
    this.bulkRun = null;
    this.masterSelected = false;
    this.selectAllInfluencer = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];
  }

  private bulkDoneMessage(result: any): string {
    // Contacts whose data was removed cannot be changed; the server leaves them out and says how many.
    const unchanged = Number(result?.dataRemovedUnchanged) || 0;
    if (!unchanged) {
      return this.bulkRun.done;
    }
    return `${this.bulkRun.done}. ${unchanged.toLocaleString()} `
      + (unchanged === 1 ? 'influencer whose data was removed was' : 'influencers whose data was removed were')
      + ' left unchanged.';
  }

  /** The app's standard confirm dialog; one that cannot be undone gets a danger button. */
  private confirmBulk(title: string, body: string, confirmLabel: string, danger = false): Promise<boolean> {
    return this.sbModal.open({
      title,
      body,
      variant: 'confirm',
      size: 'md',
      scrollable: false,
      buttons: [
        {id: 'cancel', label: 'Cancel', style: 'default', dismiss: true},
        {id: 'confirm', label: confirmLabel, style: danger ? 'danger' : 'primary', closeValue: true}
      ]
    }).result.then(() => true).catch(() => false);
  }

  deleteSelectedInfluencer() {
    this.confirmBulk(
      `Delete ${this.bulkSubject()}?`,
      'They are deleted from the whole project: removed from every campaign, along with their stats. This cannot be undone.',
      'Delete',
      true
    ).then((confirmed) => confirmed && this.runBulk('Deleting', 'Influencers deleted', {bulkAction: 'delete'}));
  }

  openMoveToSegment() {
    const selectedInfluencer = this.selectedInfluencer();
    this.onMoveTypeChange(selectedInfluencer ? Number(selectedInfluencer) : null);
    this.sbModal.open({
      title: `Move ${this.bulkSubject()} to another segment`,
      bodyTemplate: this.moveToSegmentTpl(),
      size: 'md',
      scrollable: false,
      buttons: this.moveButtons
    }).result.then(() => {
      const segment = this.moveSegments.find(item => item.id === this.moveSegmentId);
      this.runBulk('Moving', `Influencers moved to ${segment ? segment.name : 'the segment'}`, {
        bulkAction: 'update',
        updateData: {project_influencer_segment_id: this.moveSegmentId}
      });
    }, () => undefined);
  }

  onMoveTypeChange(typeId: number) {
    this.moveTypeId = typeId;
    this.moveSegments = typeId ? this.segmentsGlobal.filter(segment => segment.influencer_type_id === typeId) : [];
    this.onMoveSegmentChange(null);
  }

  onMoveSegmentChange(segmentId: number) {
    this.moveSegmentId = segmentId;
    // The dialog's Move button is this object; it stays off until there is somewhere to move to.
    this.moveButtons[1].disabled = !segmentId;
  }

  confirmSkip(option) {
    this.confirmBulk(option.title(this.bulkSubject()), option.body, option.confirm)
      .then((confirmed) => confirmed && this.runBulk('Updating', option.done, {
        bulkAction: 'update',
        updateData: {skip: option.value}
      }));
  }

  unsubscribeSelectedInfluencer(mode: 'opt_out' | 'anonymize') {
    const anonymize = mode === 'anonymize';
    const who = this.bulkSubject();
    this.confirmBulk(
      anonymize ? `Remove the personal data of ${who}?` : `Opt ${who} out of marketing emails?`,
      anonymize
        ? 'Their personal details are removed (anonymized) and they stop receiving emails for this project. This cannot be undone.'
        : 'They stop receiving marketing emails for this project.',
      anonymize ? 'Remove data' : 'Opt out',
      anonymize
    ).then((confirmed) => confirmed && this.runBulk(
      anonymize ? 'Removing data' : 'Unsubscribing',
      anonymize ? 'Personal data removed' : 'Influencers opted out of marketing emails',
      {bulkAction: 'unsubscribe', removeData: anonymize}
    ));
  }

  getInfluencerType(influencerTypeId) {
    const type = this.influencerTypes.find(item => item.id === influencerTypeId);
    return type ? type.name : '';
  }

  getInfluencerTypeForSelect(influencerTypeId) {
    const type = this.influencerTypes.find(item => item.id === influencerTypeId);
    return type ? 'Select ' + type.name : '';
  }

  getInfluencerTypeSlug(influencerTypeId) {
    const type = this.influencerTypes.find(item => item.id === influencerTypeId);
    return type ? type.slug : '';
  }

  getInfluencerSegment(segmentId) {
    const type = this.segmentsGlobal.find(item => item.id === segmentId);
    return type ? type.name : '';
  }

  showAllColumns(checked: boolean) {
    this.showAll = checked;
    // The Custom and Time to register columns go with the switch, and so do their filters: none applies unseen.
    if (!checked && (Object.keys(this.customFieldFilters()).length > 0 || this.timeToRegisterLt() != null)) {
      this.clearHeaderFilters();
      this.resetSelectionAndReload();
    }
    // The table lines its header up with the body again on a resize.
    setTimeout(() => window.dispatchEvent(new Event('resize')), 200);
  }

  includeAddedInfluencersChanged(event) {
    this.includeAddedInfluencers = event.target.checked;
    if (this.campId) {
      this.reloadTable(false);
    }
  }

  filterInfluencers(event) {
    this.masterSelected = false;
    this.selectAllInfluencer = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];
    this.influencerSegment().clearSelection();
    this.selectedInfluencer.set(null);
    this.selectedSegment.set(null);
    this.selectedPromoCode = null;
    this.selectedBadgeImageUrl = null;
    // As Promo Code and Badge: another type's contacts can use the Custom fields for other things.
    this.clearHeaderFilters();
    if (event) {
      this.selectedInfluencer.set(Number(event.value));
    }
    const selectedInfluencer = this.selectedInfluencer();
    this.changeSelectedInfluencer?.emit(selectedInfluencer);
    this.filteredSegments = [];
    if (selectedInfluencer) {
      this.filteredSegments = this.segmentsGlobal.filter(item => item.influencer_type_id === this.selectedInfluencer());
    }
    this.pageNumber = 0;

    this.reloadTable(false);
  }

  filterInfluencerSourceType(sourceValue: string) {
    this.masterSelected = false;
    this.selectAllInfluencer = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];

    const index = this.selectedSourceType().indexOf(sourceValue);
    if (index > -1) {
      this.selectedSourceType().splice(index, 1);
    } else {
      this.selectedSourceType().push(sourceValue);
    }

    const sourceType = this.sourceTypes.find(s => s.value === sourceValue);
    if (sourceType) {
      sourceType.checked = !sourceType.checked;
    }
    this.changeSelectedSourceType?.emit(this.selectedSourceType());
    this.pageNumber = 0;

    this.reloadTable(false);
  }

  getSelectedSourceNames(): string {
    if (this.selectedSourceType().length === 0) {
      return '';
    }
    return this.sourceTypes
      .filter(s => this.selectedSourceType().includes(s.value))
      .map(s => s.name)
      .join(', ');
  }

  clearSourceFilter() {
    this.selectedSourceType.set([]);
    this.sourceTypes.forEach(s => s.checked = false);
    this.changeSelectedSourceType?.emit(this.selectedSourceType());
    this.pageNumber = 0;
    this.masterSelected = false;
    this.selectAllInfluencer = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];
    this.reloadTable(false);
  }

  /**
   * The project list's filters from a bookmarked or shared address, once. The campaign list is
   * left alone: its audience comes from the campaign being edited, not from the address.
   */
  private restoreUrlFilters() {
    if (this.campId || this.urlFiltersRestored) {
      return;
    }
    this.urlFiltersRestored = true;
    const urlFilters = this.listUrlState.read(
      ['type', 'segment', 'source', 'skip', 'email', 'failed', 'removed', 'promo', 'badge',
        ...CUSTOM_FIELDS.flatMap(field => [field, `${field}_contains`]), 'timeToRegisterLt']).filters;
    const listed = (value?: string) => (value || '').split(',').filter(Boolean);
    const tick = (options: {value: string; checked: boolean}[], values: string[]) =>
      options.forEach(o => o.checked = values.includes(o.value));
    if (Number(urlFilters.type) > 0) {
      this.selectedInfluencer.set(Number(urlFilters.type));
      if (Number(urlFilters.segment) > 0) {
        this.selectedSegment.set(Number(urlFilters.segment));
      }
    }
    if (urlFilters.source) {
      this.selectedSourceType.set(listed(urlFilters.source));
      tick(this.sourceTypes, this.selectedSourceType());
    }
    if (urlFilters.skip) {
      this.selectedSkipped.set(listed(urlFilters.skip));
      tick(this.skippedType, this.selectedSkipped());
    }
    if (urlFilters.email) {
      this.selectedEmailValidationStatus.set(listed(urlFilters.email));
      tick(this.emailValidationStatusType, this.selectedEmailValidationStatus());
    }
    if (urlFilters.failed) {
      this.selectedEmailFailedReason.set(listed(urlFilters.failed));
      tick(this.emailFailedReasonType, this.selectedEmailFailedReason());
    }
    if (urlFilters.removed) {
      this.selectedDataRemoved.set(urlFilters.removed);
      tick(this.dataRemovedType, [urlFilters.removed]);
    }
    this.selectedPromoCode = urlFilters.promo || this.selectedPromoCode;
    this.selectedBadgeImageUrl = urlFilters.badge || this.selectedBadgeImageUrl;
    const customFilters: {[field: string]: CustomFieldFilter} = {};
    CUSTOM_FIELDS.forEach(field => {
      const presence = urlFilters[field];
      const contains = (urlFilters[`${field}_contains`] || '').trim();
      if (presence === 'empty' || presence === 'not_empty') {
        customFilters[field] = {presence};
      } else if (contains) {
        customFilters[field] = {contains};
        this.customFieldDrafts[field] = contains;
      }
    });
    if (Object.keys(customFilters).length > 0) {
      this.customFieldFilters.set(customFilters);
      // The Custom columns show only with "Display all columns": a filter on one stays in sight.
      this.showAll = true;
    }
    const timeToRegisterLt = parseTimeToRegister(urlFilters.timeToRegisterLt);
    if (timeToRegisterLt) {
      this.timeToRegisterLt.set(timeToRegisterLt);
      // As the Custom filters: the column shows only with "Display all columns".
      this.showAll = true;
    }
  }

  /** The Custom columns' filters as the list endpoint reads them. */
  private customFieldParams(): {[key: string]: string} {
    const params: {[key: string]: string} = {};
    Object.entries(this.customFieldFilters()).forEach(([field, filter]) => {
      if (filter.presence) {
        params[field] = filter.presence;
      } else if (filter.contains) {
        params[`${field}_contains`] = filter.contains;
      }
    });
    return params;
  }

  customFieldFilterActive(field: string): boolean {
    return !!this.customFieldFilters()[field];
  }

  customFieldPresence(field: string): string {
    return this.customFieldFilters()[field]?.presence || '';
  }

  /** The text box's value, on Enter or Apply: the values holding it, or no filter when blank. */
  applyCustomFieldText(field: string) {
    const contains = (this.customFieldDrafts[field] || '').trim();
    this.customFieldDrafts[field] = contains;
    const current = this.customFieldFilters()[field];
    if ((current?.contains || '') === contains && !current?.presence) {
      return;
    }
    this.setCustomFieldFilter(field, contains ? {contains} : null);
  }

  /** "Empty" and "Not empty" replace the text; "Any value" applies the text box again. */
  filterCustomFieldPresence(field: string, presence: string) {
    if (presence === 'empty' || presence === 'not_empty') {
      this.customFieldDrafts[field] = '';
      this.setCustomFieldFilter(field, {presence});
    } else {
      const contains = (this.customFieldDrafts[field] || '').trim();
      this.setCustomFieldFilter(field, contains ? {contains} : null);
    }
  }

  clearCustomFieldFilter(field: string) {
    this.customFieldDrafts[field] = '';
    if (this.customFieldFilterActive(field)) {
      this.setCustomFieldFilter(field, null);
    }
  }

  private setCustomFieldFilter(field: string, filter: CustomFieldFilter | null) {
    const {[field]: _previous, ...others} = this.customFieldFilters();
    this.customFieldFilters.set(filter ? {...others, [field]: filter} : others);
    this.resetSelectionAndReload();
  }

  /** The Time to register filter as the list endpoint reads it. */
  private timeToRegisterParams(): {timeToRegisterLt?: number} {
    const seconds = this.timeToRegisterLt();
    return seconds ? {timeToRegisterLt: seconds} : {};
  }

  filterTimeToRegister(seconds: number | null) {
    if (seconds !== this.timeToRegisterLt()) {
      this.timeToRegisterLt.set(seconds);
      this.resetSelectionAndReload();
    }
  }

  /** How long a referred contact took to register, from the referrer's click; empty when unknown. */
  timeToRegister(influencer: {referral_time_to_register?: number | null}): string {
    const seconds = influencer?.referral_time_to_register;
    return seconds == null ? '' : humanDuration(seconds);
  }

  /** Every header filter: the Custom columns' and Time to register. */
  private clearHeaderFilters() {
    this.clearCustomFieldFilters();
    this.timeToRegisterLt.set(null);
  }

  private clearCustomFieldFilters() {
    this.customFieldFilters.set({});
    this.customFieldDrafts = {};
  }

  /** A filter changed: the selection no longer matches the list, which starts again on page one. */
  private resetSelectionAndReload() {
    this.masterSelected = false;
    this.selectAllInfluencer = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];
    this.pageNumber = 0;
    this.reloadTable(false);
  }

  // Once per mode, so a choice the user made survives query-param changes within the same list.
  private applyDefaultSkipped() {
    const mode = this.campId ? 'campaign' : 'project';
    if (this.skippedDefaultsAppliedFor === mode) {
      return;
    }
    this.skippedDefaultsAppliedFor = mode;
    this.selectedSkipped.set(mode === 'campaign' ? [...this.campaignDefaultSkipped] : []);
    this.skippedType.forEach(s => s.checked = this.selectedSkipped().includes(s.value));
  }

  filterSkipped(skipValue: string) {
    this.masterSelected = false;
    this.selectAllInfluencer = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];

    const index = this.selectedSkipped().indexOf(skipValue);
    if (index > -1) {
      this.selectedSkipped().splice(index, 1);
    } else {
      this.selectedSkipped().push(skipValue);
    }

    const skipType = this.skippedType.find(s => s.value === skipValue);
    if (skipType) {
      skipType.checked = !skipType.checked;
    }

    this.changeSelectedSkipped?.emit(this.selectedSkipped());
    this.pageNumber = 0;

    this.reloadTable(false);
  }

  getSelectedSkippedNames(): string {
    if (this.selectedSkipped().length === 0) {
      return '';
    }
    return this.skippedType
      .filter(s => this.selectedSkipped().includes(s.value))
      .map(s => s.name)
      .join(', ');
  }

  clearSkippedFilter() {
    this.selectedSkipped.set([]);
    this.skippedType.forEach(s => s.checked = false);
    this.changeSelectedSkipped?.emit(this.selectedSkipped());
    this.pageNumber = 0;
    this.masterSelected = false;
    this.selectAllInfluencer = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];
    this.reloadTable(false);
  }

  filterEmailValidationStatus(statusValue: string) {
    this.masterSelected = false;
    this.selectAllInfluencer = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];

    const index = this.selectedEmailValidationStatus().indexOf(statusValue);
    if (index > -1) {
      this.selectedEmailValidationStatus().splice(index, 1);
    } else {
      this.selectedEmailValidationStatus().push(statusValue);
    }

    const statusType = this.emailValidationStatusType.find(s => s.value === statusValue);
    if (statusType) {
      statusType.checked = !statusType.checked;
    }

    this.changeSelectedEmailValidationStatus?.emit(this.selectedEmailValidationStatus());
    this.pageNumber = 0;

    this.reloadTable(false);
  }

  filterEmailFailedReason(reasonValue: string) {
    this.masterSelected = false;
    this.selectAllInfluencer = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];

    const index = this.selectedEmailFailedReason().indexOf(reasonValue);
    if (index > -1) {
      this.selectedEmailFailedReason().splice(index, 1);
    } else {
      this.selectedEmailFailedReason().push(reasonValue);
    }

    const reasonType = this.emailFailedReasonType.find(s => s.value === reasonValue);
    if (reasonType) {
      reasonType.checked = !reasonType.checked;
    }

    this.changeSelectedEmailFailedReason?.emit(this.selectedEmailFailedReason());
    this.pageNumber = 0;

    this.reloadTable(false);
  }

  loadAppliedActionOptions() {
    if (!this.campId) {
      this.appliedActionType = [];
      return;
    }
    this.influencerService.getCampaignAppliedActions(this.campId).subscribe((res: any) => {
      const actions: string[] = (res && res.data) ? res.data : [];
      const namedActions = actions.filter(a => !!a);
      this.cdr.markForCheck();
      this.appliedActionType = [
        ...namedActions.map(action => ({
          name: action,
          value: action,
          checked: this.selectedAppliedAction().includes(action)
        })),
        {
          name: 'Empty',
          value: 'empty',
          checked: this.selectedAppliedAction().includes('empty')
        }
      ];
    });
  }

  filterAppliedAction(actionValue: string) {
    this.masterSelected = false;
    this.selectAllInfluencer = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];

    const index = this.selectedAppliedAction().indexOf(actionValue);
    if (index > -1) {
      this.selectedAppliedAction().splice(index, 1);
    } else {
      this.selectedAppliedAction().push(actionValue);
    }

    const actionType = this.appliedActionType.find(s => s.value === actionValue);
    if (actionType) {
      actionType.checked = !actionType.checked;
    }

    this.changeSelectedAppliedAction?.emit(this.selectedAppliedAction());
    this.pageNumber = 0;

    this.reloadTable(false);
  }

  filterDataRemoved(event) {
    this.masterSelected = false;
    this.selectAllInfluencer = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];
    this.selectedDataRemoved.set(null);
    if (event) {
      this.selectedDataRemoved.set(event.value);
    }
    this.changeSelectedDataRemoved?.emit(this.selectedDataRemoved());
    this.pageNumber = 0;

    this.reloadTable(false);
  }

  filterDataRemovedFromColumn(value: string) {
    this.masterSelected = false;
    this.selectAllInfluencer = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];

    if (this.selectedDataRemoved() === value) {
      this.selectedDataRemoved.set(null);
      this.dataRemovedType.forEach(o => o.checked = false);
    } else {
      this.selectedDataRemoved.set(value);
      this.dataRemovedType.forEach(o => o.checked = o.value === value);
    }

    this.changeSelectedDataRemoved?.emit(this.selectedDataRemoved());
    this.pageNumber = 0;
    this.reloadTable(false);
  }

  clearDataRemovedFilter() {
    this.masterSelected = false;
    this.selectAllInfluencer = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];
    this.selectedDataRemoved.set(null);
    this.dataRemovedType.forEach(o => o.checked = false);
    this.changeSelectedDataRemoved?.emit(this.selectedDataRemoved());
    this.pageNumber = 0;
    this.reloadTable(false);
  }

  filterPromoCode(event) {
    this.masterSelected = false;
    this.selectAllInfluencer = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];
    this.selectedPromoCode = null;
    if (event) {
      this.selectedPromoCode = event.value;
    }
    this.pageNumber = 0;
    this.reloadTable(false);
  }

  filterBadgeImageUrl(event) {
    this.masterSelected = false;
    this.selectAllInfluencer = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];
    this.selectedBadgeImageUrl = null;
    if (event) {
      this.selectedBadgeImageUrl = event.value;
    }
    this.pageNumber = 0;
    this.reloadTable(false);
  }

  filterSegments(event) {
    this.masterSelected = false;
    this.selectAllInfluencer = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];
    this.pageNumber = 0;    this.pageNumber = 0;
    if (this.selectedInfluencer()) {
      this.selectedSegment.set(null);
      if (event) {
        this.selectedSegment.set(Number(event.value));
      }
      this.changeSelectedSegment?.emit(this.selectedSegment());
      this.reloadTable(false);

    }
  }


  importInfluencers() {
    this.loader$ = null;
    const modelRef = this.sbModal.openComponent(InfluencersImportComponent, {
      centered: false,
      size: 'xl',
      keyboard: true
    }, {
      influencerTypes: this.influencerTypes,
      segments: this.segmentsGlobal,
      projectId: this.id,
      selectedInfluencer: this.selectedInfluencer(),
    });
    modelRef.result.then((result) => {
      this.loader$ = this.loaderService.loader$;
      this.reloadTable();
      this.cdr.markForCheck();
    }, (reason) => {
      this.loader$ = this.loaderService.loader$;
      this.reloadTable();
      this.cdr.markForCheck();
    });
  }

  getSessionTitle(influencer) {
    return influencer?.sessions?.map(item => item.title).join(' | ') || '';
  }

  getSessions(influencer) {
    let sessions = [];
    if (Array.isArray(influencer.sessions)) {
      sessions = influencer.sessions.map(s => ({
        ...s,
        formatted_start_time: s.start_time
          ? moment.utc(s.start_time).tz(this.currentUser.timezone).format('MM/DD/YYYY HH:mm')
          : null,
        formatted_end_time: s.end_time
          ? moment.utc(s.end_time).tz(this.currentUser.timezone).format('MM/DD/YYYY HH:mm')
          : null
      }));
    }
    return `<table border="1" cellpadding="6" cellspacing="0">
              <thead>
                <tr>
                  <th>Title</th><th>Description</th><th>Start</th><th>End</th>
                </tr>
              </thead>
              <tbody>
                ${sessions.map(s => `
                  <tr>
                    <td>${s.title}</td>
                    <td>${s.description || ''}</td>
                    <td>${s.formatted_start_time || ''}</td>
                    <td>${s.formatted_end_time || ''}</td>
                  </tr>`).join('')}
              </tbody>
            </table>`;
  }

  // exportInfluencers() {
  //   const commonFields = ['id', 'name', 'description', 'pageViews', 'referred_count', 'public_info_update_page_url', 'source', 'created_at', 'updated_at'];
  //   const fieldsWithConditions = ['email', 'image', 'influencer_type_id', 'project_influencer_segment_id',
  //     'registration_url', 'company', 'title', 'first_name', 'last_name',
  //     'phone', 'video_url', 'booth_number', 'job_title', 'sessions',
  //     'custom_1', 'custom_2', 'custom_3', 'custom_4', 'custom_5',
  //     'custom_6', 'custom_7', 'custom_8', 'custom_9', 'custom_10',
  //     'referred_by', 'referred_by_campaign_id', 'referred_through_tracker_source'];
  //
  //   let fieldsToInclude = [];
  //   // if (this.showAll) {
  //     fieldsToInclude = fieldsWithConditions.filter(fieldName => (!this.selectedInfluencer ||
  //       (this.selectedInfluencer && this.influencerTypesById[this.selectedInfluencer][fieldName])));
  //   // }
  //   fieldsToInclude = [...commonFields, ...fieldsToInclude];
  //   const filters = {
  //     options: JSON.stringify({includePagination: false, orderBy: {'column': 'created_at', 'dir': 'desc'}}),
  //     fieldsToInclude: JSON.stringify(fieldsToInclude),
  //     project_id: this.id,
  //     ...(this.selectedInfluencer ? {influencer_type_id: this.selectedInfluencer} : {}),
  //     ...(this.referredByInfluencer ? {referred_by: Number(this.referredByInfluencer.id)} : {}),
  //     ...(this.selectedSegment ? {project_influencer_segment_id: this.selectedSegment} : {}),
  //     timezone: this.currentUser.timezone,
  //     v1: (new Date()).getTime()
  //   };
  //
  //   const params = Object.keys(filters).map(key => `${key}=${filters[key]}`).join('&');
  //   window.open(`${environment.apiUrl}/api/v1/influencer/export/download?${params}`, '_blank');
  // }

  exportInfluencers(exportType) {
    const commonFields = ['id', 'name', 'description', 'pageViews', 'referred_count', 'campaign_influencer_page_url', 'campaign_influencer_share_page_url', 'public_info_update_page_url', 'source', 'email_open', 'email_click', 'email_status', 'created_at', 'updated_at', 'email_open_tracker_html', 'email_open_tracker_url', 'share_link_tracker_url', 'personalized_images', 'data_removed', 'suppress_email', 'email_frequency', 'suppress_email_open_tracking', 'suppress_all_tracking', 'preference_reason', 'skip', 'platform_unique_id'];
    let fieldsWithConditions = ['email', 'image', 'influencer_type_id', 'project_influencer_segment_id',
      'registration_url', 'company', 'prefix', 'first_name', 'last_name', 'suffix', 'phone', 'video_url', 'booth_number', 'job_title',
      'session_title', 'session_description', 'session_start_time', 'session_end_time', 'promo_code', 'badge_image_url',
      'custom_1', 'custom_2', 'custom_3', 'custom_4', 'custom_5', 'custom_6', 'custom_7', 'custom_8', 'custom_9', 'custom_10', 'custom_message'];

    if (!this.campId) {
      fieldsWithConditions = [...fieldsWithConditions, 'referred_by', 'referred_by_campaign_id', 'referred_through_tracker_source'];
    }

    this.uniqueImportString = (new Date().getTime()).toString(36);

    this.exportProcess = false;
    if (!['finished', 'failed'].includes(this.exportProgress().status)) {
      this.csvDownloadComplete.set(false);
    }
    let fieldsToInclude = [];
    // if (this.showAll) {
    fieldsToInclude = fieldsWithConditions.filter(fieldName => {
      const selectedInfluencer = this.selectedInfluencer();
      return (!selectedInfluencer ||
      (selectedInfluencer && this.influencerTypesById[selectedInfluencer][fieldName]));
    });
    // }

    if (this.campId) {
      fieldsToInclude = [...fieldsToInclude, 'applied_action', 'email_failed_reason', 'email_failed_reason_info'];
    }

    let selectedSegments = null;
    if (this.campId && this.campaign) {
      selectedSegments = this.selectedInfluencerSegmentPairs().filter(x => x.segment !== null).map(x => x.segment.id);
      selectedSegments = [...new Set(selectedSegments)];
    }

    fieldsToInclude = [...commonFields, ...fieldsToInclude];
    const selectedAppliedAction = this.selectedAppliedAction();
    const selectedInfluencerValue = this.selectedInfluencer();
    const selectedSegment = this.selectedSegment();
    const selectedSourceType = this.selectedSourceType();
    const selectedSkipped = this.selectedSkipped();
    const selectedDataRemoved = this.selectedDataRemoved();
    const filters = {
      exportType,
      options: JSON.stringify({includePagination: false, orderBy: {column: 'created_at', dir: 'desc'}}),
      fieldsToInclude: JSON.stringify(fieldsToInclude),
      project_id: this.id,
      uniqueImportString: this.uniqueImportString,
      ...(this.campId ? {campaign_id: this.campId} : {}),
      ...(selectedInfluencerValue ? {influencer_type_id: selectedInfluencerValue} : {}),
      ...(!this.campId && selectedSegment ? {project_influencer_segment_ids: [selectedSegment]} : {}),
      ...(this.campId && selectedSegments.length > 0 ? {project_influencer_segment_ids: selectedSegments} : {}),
      ...(this.campId && this.includeAddedInfluencers ? {include_campaign_influencers: 'true'} : {}),
      ...(this.referredByInfluencer ? {referred_by: Number(this.referredByInfluencer.id)} : {}),
      ...(selectedSourceType && selectedSourceType.length > 0 ? {source: selectedSourceType.join(',')} : {}),
      ...(selectedSkipped && selectedSkipped.length > 0 ? {skip: selectedSkipped.join(',')} : {}),
      // `influencer_preference` is the key the export endpoint reads (same as the list calls
      // above); `data_removed` was never one of its params, so the filter was being dropped.
      ...(selectedDataRemoved ? {influencer_preference: selectedDataRemoved} : {}),
      ...(this.campId && selectedAppliedAction && selectedAppliedAction.length > 0 ? {applied_action: selectedAppliedAction.join(',')} : {}),
      timezone: this.currentUser.timezone,
      v1: (new Date()).getTime()
    };

    const params = Object.keys(filters).map(key => `${key}=${filters[key]}`).join('&');
    if(!this.csvDownloadComplete()) {
      this.setExportProgress({status: 'started', progress: '0'});
    }
    this.exportModelRef = this._modalService.open(this.csvDownload(), {
      centered: true,
      size: 'md',
      keyboard: true,
    });
    this.exportModelRef.result.then((result) => {
    }, (reason) => {
    });


    this.influencerStore.dispatch(InfluencersExport({data: filters}));

    // setTimeout(() => {
    //   modelRef.close();
    // },1500);
    // window.open(`${environment.apiUrl}/api/v1/influencer/export/download?${params}`);

  }

  showReferralList(id: number, name: string) {
    this.loader$ = null;
    const modelRef = this.sbModal.openComponent(ReferralsListComponent, {
      centered: false,
      size: 'xl',
      keyboard: true
    }, {
      influencerId: id,
      influencerName: name,
      influencerTypes: this.influencerTypes,
      segmentsGlobal: this.segmentsGlobal,
    });
    modelRef.result.then((result) => {
      this.loader$ = this.loaderService.loader$;
      this.cdr.markForCheck();
    }, (reason) => {
      this.loader$ = this.loaderService.loader$;
      this.cdr.markForCheck();
    });
  }

  manageSegments(influencerType?: number, pairIndex?: number) {
    this.loader$ = null;
    const modelRef = this.sbModal.openComponent(SegmentListComponent, {
      centered: false,
      size: 'xl',
      keyboard: true
    }, {
      projectId: this.id,
      selectedInfluencer: influencerType,
    });
    modelRef.result.then((result) => {
      // Reload segments to get updated segment names
      this.segmentIsLoading = false;
      this.getSegments();
      if(result && result.segment) {
        if (this.campId && pairIndex !== undefined && pairIndex !== null) {
          this.onSegmentSelected(pairIndex, result.segment);
        } else {
          this.selectedSegment.set(Number(result.segment?.id));
          this.reloadTable(false);
        }
      }
      this.loader$ = this.loaderService.loader$;
      this.cdr.markForCheck();
    }, (reason) => {
      // Reload segments even if modal was dismissed to catch any changes
      this.segmentIsLoading = false;
      this.getSegments();
      this.loader$ = this.loaderService.loader$;
      this.cdr.markForCheck();
    });
  }

  formatInsertTime(insertTime) {
    insertTime = moment(insertTime, 'YYYY-MM-DD[T]HH[:]mm[:]00[.000Z]');
    if (insertTime.isValid()) {
      return insertTime.format('DD-MM-YYYY hh:mm a');
    }
    return '-';
  }

  humanize(value: string): string {
    if (!value) {
      return '';
    }
    return value.replace(/[_-]/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }

  formatMoment(insertTime) {
    insertTime = moment(insertTime, 'YYYY-MM-DD[T]HH[:]mm[:]00[.000Z]');
    if (insertTime.isValid()) {
      return insertTime;
    }
    return null;
  }

  formatSkipValue(skip: string): string {
    if (!skip) {
      return '';
    }

    if (skip === 'campaign_email') {
      return 'Excluded From Receiving Campaign Email';
    } else if (skip === 'campaign_inclusion') {
      return 'Excluded From Campaign';
    } else {
      return skip.split('_').join(' ');
    }
  }

  getCreateUpdateInfo(user) {
    if (user) {
      if ((user.hasOwnProperty('first_name') && user.first_name) || (user.hasOwnProperty('last_name') && user.last_name)) {
        return `${user.first_name ? user.first_name : ''} ${user.last_name ? user.last_name : ''}`;
      } else if (user.hasOwnProperty('email') && user.email) {
        return user.email;
      }
    }
  }

  filterReferredByInfluencer(influencer) {
    this.pageNumber = 0;
    if (influencer) {
      this.referredByInfluencer = influencer;
    }
    this.filteredSegments = [];
    if (this.referredByInfluencer) {
      this.filteredSegments = this.segmentsGlobal.filter(item => Number(item.referredBy) === Number(this.referredByInfluencer.id));
    }
    this.reloadTable(false);
  }

  clearReferredByInfluencer(event: object) {
    if (event) {
      this.referredByInfluencer = null;
      this.reloadTable(false);
    }
  }

  checkUncheckAllInfluencer() {
    if (!this.masterSelected) {
      if (!this.excludedPageList.includes(this.rowsPage)) {
        this.excludedPageList.push(this.rowsPage);
      }
      const index = this.includedPageList.indexOf(this.rowsPage);
      if (index > -1) {
        this.includedPageList.splice(index, 1);
      }
    } else {
      const index = this.excludedPageList.indexOf(this.rowsPage);
      if (index > -1) {
        this.excludedPageList.splice(index, 1);
      }
      if (!this.includedPageList.includes(this.rowsPage)) {
        this.includedPageList.push(this.rowsPage);
      }
    }

    this.influencersLocal.update((list) => list.map((item) => ({
      ...item,
      selected: this.masterSelected
    })));
    this.fetchCheckedIDs();
  }

  onChangeInfluencerSelection(checked, id) {
    if (this.selectAllInfluencer) {
      if (!checked) {
        if (!this.excludedIdList.includes(id)) {
          this.excludedIdList.push(id);
          this.influencerCount -= 1;
        }
      } else {
        const index = this.excludedIdList.indexOf(id);
        if (index > -1) {
          this.excludedIdList.splice(index, 1);
          this.influencerCount += 1 ;
        }
      }
    } else {
      if (checked) {
        if (!this.includedIdList.includes(id)) {
          this.includedIdList.push(id);
        }
      } else {
        const index = this.includedIdList.indexOf(id);
        if (index > -1) {
          this.includedIdList.splice(index, 1);
        }
      }
    }

    const selectedInfluencers = this.influencersLocal().filter((item) => item.selected);
    this.masterSelected = selectedInfluencers.length === this.influencersLocal().length;
    if (!this.masterSelected && !this.excludedPageList.includes(this.rowsPage)) {
      this.excludedPageList.push(this.rowsPage);
    }
    if (!this.masterSelected && this.includedPageList.includes(this.rowsPage)) {
      const index = this.includedPageList.indexOf(this.rowsPage);
      if (index > -1) {
        this.includedPageList.splice(index, 1);
      }
    }
  }

  bulkStatus() {
    this.influencerStore.dispatch(InfluencersBulkStatus({importJobId: this.importJobId}));
  }

  isImportDataFilled() {
    return this.importData && Object.keys(this.importData).length > 0;
  }

  importDataTableColumns() {
    return this.importData['columns'];
  }

  fetchSelectedItems() {
    this.checkedInfluencer = this.influencersLocal().filter((value, index) => value.selected);
    this.fetchCheckedIDs();
  }

  fetchCheckedIDs() {
    this.influencersLocal().forEach((value) => {
      if (value.selected) {
        if (this.selectAllInfluencer) {
          const index = this.excludedIdList.indexOf(value.id);
          if (index > -1) {
            this.excludedIdList.splice(index, 1);
            this.influencerCount += 1 ;
          }
        } else {
          if (!this.includedIdList.includes(value.id)) {
            this.includedIdList.push(value.id);
          }
        }
      } else {
        if (this.selectAllInfluencer) {
          if (!this.excludedIdList.includes(value.id)) {
            this.excludedIdList.push(value.id);
            this.influencerCount -= 1;
          }
        } else {
          const index = this.includedIdList.indexOf(value.id);
          if (index > -1) {
            this.includedIdList.splice(index, 1);
          }
        }
      }
    });
  }

  checkAllInfluencer() {
    this.selectAllInfluencer = true;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];
    this.checkUncheckAllInfluencer();
  }

  uncheckAllInfluencer() {
    this.selectAllInfluencer = false;
    this.masterSelected = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];
    this.checkUncheckAllInfluencer();
  }

  showDeleteLogs() {
    const modelRef = this._modalService.open(this.logsTable(), {
      centered: false,
      size: 'xl',
      keyboard: false,
      backdrop : 'static',
    });
    modelRef.result.then((result) => {
    }, (reason) => {
    });
  }

  openPreferenceHistory(influencer: Influencer) {
    this.preferenceHistoryInfluencer = influencer;
    this.preferenceHistory.set([]);
    this.preferenceHistoryLoading.set(true);
    this._modalService.open(this.preferenceHistoryTpl(), {
      centered: true,
      size: 'lg',
      keyboard: true,
    });
    this.influencerApiService.getPreferenceHistory(influencer.id).subscribe({
      next: (res) => {
        // controllerResult → { success, data: { list } }; HttpService observe:'response' → res.body
        const payload = res?.body ?? res;
        const data = payload?.data ?? payload?.result ?? payload;
        const list = Array.isArray(data?.list) ? data.list
          : (Array.isArray(payload?.list) ? payload.list
            : (Array.isArray(data) ? data : []));
        this.preferenceHistoryUsers.set(data?.usersById || payload?.usersById || {});
        this.preferenceHistory.set(list.map((rev) => ({
          ...rev,
          _summary: this.getPreferenceRevisionSummary(rev),
          _changes: this.getPreferenceRevisionChanges(rev),
        })));
        this.preferenceHistoryLoading.set(false);
      },
      error: () => {
        this.preferenceHistoryLoading.set(false);
        this.toastr.error('Unable to load preference history');
      }
    });
  }

  private preferenceFieldLabels: {[key: string]: string} = {
    email_frequency: 'Email frequency',
    email_paused_until: 'Paused until',
    marketing_email_opt_out: 'Marketing email opt-out',
    all_email_opt_out: 'All email opt-out',
    // Legacy revision keys
    email_opt_out: 'Marketing email opt-out',
    transactional_email_opt_out: 'All email opt-out',
    email_open_tracking_opt_out: 'No email open tracking',
    all_tracking_opt_out: 'No tracking',
    data_removal: 'Data removal',
    data_removed_at: 'Data removed at',
    reason: 'Reason',
    through: 'Source',
    created_by: 'Created by',
    updated_by: 'Updated by',
  };

  private preferenceHistorySkipKeys = new Set([
    'id', 'email_hash', 'scope', 'project_id', 'created_at', 'updated_at',
    'influencer_id', 'influencer_code', 'campaign_id', 'client_id',
    'project_influencer_segment_id', 'ip', 'user_agent', 'action'
  ]);

  // Where a preference change came from (`through` on the server). 'manual' is what the panel
  // recorded before 'admin_panel'.
  private preferenceSourceLabels: {[key: string]: string} = {
    email: 'Preference page (email link)',
    one_click: 'One-click unsubscribe',
    admin_panel: 'Admin panel',
    manual: 'Admin panel',
    widget: 'Share widget',
    api: 'API',
  };

  formatPreferenceSource(through: string): string {
    if (!through) {
      return 'system';
    }
    return this.preferenceSourceLabels[through] || through;
  }

  formatPreferenceFieldLabel(key: string): string {
    return this.preferenceFieldLabels[key] || key;
  }

  formatEmailFrequencyLabel(frequency: string): string {
    if (!frequency || frequency === 'standard') {
      return '';
    }
    return this.emailFrequencyLabels[frequency] || String(frequency).toUpperCase();
  }

  isEmailPauseFrequency(frequency: string): boolean {
    return frequency === 'pause_30' || frequency === 'pause_90';
  }

  preferenceUserName(id: any): string {
    if (id === undefined || id === null || id === '') {
      return '';
    }
    return this.preferenceHistoryUsers()[String(id)] || ('#' + id);
  }

  formatPreferenceValue(value: any, field?: string): string {
    if (value === undefined || value === null || value === '') {
      return '—';
    }
    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    }
    if (field === 'email_frequency') {
      const label = this.formatEmailFrequencyLabel(String(value));
      return label || String(value);
    }
    if (field === 'created_by' || field === 'updated_by') {
      return this.preferenceUserName(value);
    }
    if (field === 'through') {
      return this.formatPreferenceSource(String(value));
    }
    return String(value);
  }

  getPreferenceRevisionSummary(rev: any): string {
    if (!rev) {
      return '';
    }
    const data = typeof rev.data === 'string'
      ? (() => {
        try {
          return JSON.parse(rev.data || '{}');
        } catch {
          return {};
        }
      })()
      : (rev.data || {});
    if (data.action === 'data_removal' || data.data_removal === true) {
      return 'Data removal';
    }
    if (data.action === 'opt_in') {
      return 'Opt-in / restore';
    }
    if (rev.operation === 'create') {
      return 'Preferences created';
    }
    return '';
  }

  getPreferenceRevisionChanges(rev: any): {field: string; from: any; to: any}[] {
    if (!rev) {
      return [];
    }
    const changed = rev.data_changed || {};
    let keys = Object.keys(changed);
    if (!keys.length) {
      return [];
    }

    // Prefer meaningful preference fields; fall back to all if nothing left
    const meaningful = keys.filter((k) => !this.preferenceHistorySkipKeys.has(k));
    if (meaningful.length) {
      keys = meaningful;
    }

    return keys.map((field) => {
      const c = changed[field];
      // create revisions often store the full row as data_changed (flat values, not {from,to})
      if (c && typeof c === 'object' && ('from' in c || 'to' in c)) {
        return {field, from: c.from, to: c.to};
      }
      return {field, from: null, to: c};
    }).filter((change) => {
      // Only show created_by/updated_by rows when an actual admin id is present (skip the
      // empty null→null attribution row on an anonymous end-user create).
      if (change.field === 'created_by' || change.field === 'updated_by') {
        const empty = (v) => v === null || v === undefined || v === '';
        return !(empty(change.from) && empty(change.to));
      }
      return true;
    });
  }

  close() {
    this.influencersLocal.update((list) => list.map((item) => ({
      ...item,
      selected: false
    })));
  }



  refreshFilteredSegments(reload = true) {
    if (this.selectedInfluencerSegmentPairs().length > 0) {
      const lastPair = this.selectedInfluencerSegmentPairs()[this.selectedInfluencerSegmentPairs().length - 1];
      if (lastPair.influencerType !== null && lastPair.segment !== null) {
        this.selectedInfluencerSegmentPairs().push({
          influencerType: this.selectedInfluencerSegmentPairs()?.length > 0 ? this.selectedInfluencerSegmentPairs()[0].influencerType : null,
          segment: null,
          filteredSegments: []
        });
      }
    }

    for (let i = 0; i < this.selectedInfluencerSegmentPairs().length; i++) {
      const pair = this.selectedInfluencerSegmentPairs()[i];

      if (!pair.influencerType) {
        pair.filteredSegments = [];
        continue;
      }

      const selectedTypeId = Number(pair.influencerType.id);

      const matchingSegments = this.segmentsGlobal.filter(
        segment => segment.influencer_type_id === selectedTypeId
      );

      const usedSegmentIds = this.selectedInfluencerSegmentPairs()
        .filter((p, idx) =>
          idx !== i &&
          p.influencerType?.id === selectedTypeId &&
          p.segment
        )
        .map(p => p.segment.id);

      pair.filteredSegments = matchingSegments
        .filter(s => !usedSegmentIds.includes(s.id));
    }

    this.changeSelectedInfluencerSegmentPairs?.emit(this.selectedInfluencerSegmentPairs());

    if (!reload) {
      return;
    }
    this.masterSelected = false;
    this.selectAllInfluencer = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];
    this.pageNumber = 0;    this.pageNumber = 0;
    if (!this.campId || this.campaign) {
      this.reloadTable(false);
    }
  }

  onInfluencerTypeSelected(index: number, selectedInfluencer: any) {
    const pair = this.selectedInfluencerSegmentPairs()[index];
    const influencerType = selectedInfluencer == null ? null : this.influencerTypes.find(item => item.id === (selectedInfluencer.id || selectedInfluencer.value));
    // As on the project list's type select.
    if (this.selectedInfluencerSegmentPairs().some(p => p.influencerType?.id !== influencerType?.id)) {
      this.clearHeaderFilters();
    }

    this.selectedInfluencerSegmentPairs().forEach((p, idx) => {
      if (p.influencerType?.id !== influencerType?.id) {
        p.influencerType = influencerType;
        p.segment = null;
        p.filteredSegments = [];
      }
    });

    const lastIndex = this.selectedInfluencerSegmentPairs().length - 1;
    this.selectedInfluencerSegmentPairs.set(this.selectedInfluencerSegmentPairs().filter((p, idx) => {
      if (idx === lastIndex || p.segment !== null) {
        return true;
      } else {
        return false;
      }
    }));

    if (this.selectedInfluencerSegmentPairs().length <= 1 && selectedInfluencer == null) {
      this.masterSelected = false;
      this.selectAllInfluencer = false;
      this.includedIdList = [];
      this.excludedPageList = [];
      this.includedPageList = [];
      this.excludedIdList = [];
      this.pageNumber = 0;    this.pageNumber = 0;
    }

    this.refreshFilteredSegments();
  }

  onSegmentSelected(index: number, selectedSegment: any) {
    const current = this.selectedInfluencerSegmentPairs()[index];

    current.segment = selectedSegment == null ? null : {
      ...selectedSegment,
      id: selectedSegment.id || selectedSegment.value
    };
    this.refreshFilteredSegments();

    this.masterSelected = false;
    this.selectAllInfluencer = false;
    this.includedIdList = [];
    this.excludedPageList = [];
    this.includedPageList = [];
    this.excludedIdList = [];
    this.pageNumber = 0;    this.pageNumber = 0;
  }

  addPair() {
    this.selectedInfluencerSegmentPairs().push({
      influencerType: null,
      segment: null,
      filteredSegments: []
    });

    this.refreshFilteredSegments();
  }

  removePair(index: number) {
    this.selectedInfluencerSegmentPairs().splice(index, 1);

    this.refreshFilteredSegments();
  }

  dropSegmentPair(event: CdkDragDrop<any[]>) {
    const lastIndex = this.selectedInfluencerSegmentPairs().length - 1;
    if (event.previousIndex === lastIndex || event.currentIndex === lastIndex) {
      return;
    }
    const selectedInfluencerSegmentPairs = this.selectedInfluencerSegmentPairs();
    moveItemInArray(selectedInfluencerSegmentPairs, event.previousIndex, event.currentIndex);
    this.changeSelectedInfluencerSegmentPairs.emit(selectedInfluencerSegmentPairs);
  }

  addUnaddedPair(unaddedPair) {
    if (this.selectedInfluencerSegmentPairs().length > 0) {
      const lastPair = this.selectedInfluencerSegmentPairs()[this.selectedInfluencerSegmentPairs().length - 1];
      if (lastPair.segment == null) {
        this.selectedInfluencerSegmentPairs()[this.selectedInfluencerSegmentPairs().length - 1] = unaddedPair;
      } else {
        this.selectedInfluencerSegmentPairs().push(unaddedPair);
      }
    } else {
      this.selectedInfluencerSegmentPairs().push(unaddedPair);
    }

    this.refreshFilteredSegments();
  }

  hasPartnerInfluencerType() {
    return !this.campId || this.selectedInfluencerSegmentPairs().some(item => item.influencerType && item.segment && item.influencerType.slug === 'partner');
  }

  hasNonPartnerInfluencerType() {
    const pairs = this.selectedInfluencerSegmentPairs().filter(item => item.influencerType && item.segment);
    return !this.campId || pairs.length === 0 || pairs.filter(item => item.influencerType.slug !== 'partner').length > 0;
  }

  getAddInfluencerQueryParams() {
    if (this.campId && this.selectedInfluencerSegmentPairs().length > 0) {
      const pair = this.selectedInfluencerSegmentPairs()[0];
      return {
        selectedInfluencerType: pair.influencerType?.id || null,
        selectedSegment: pair.segment?.id || null,
        campaignId: this.campId
      };
    }
    return {
      selectedInfluencerType: this.selectedInfluencer(),
      selectedSegment: this.selectedSegment(),
      campaignId: this.campId
    };
  }

  ngOnDestroy() {
    this.unsubscriber.next(undefined);
    this.unsubscriber.complete();
  }
}
